import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { Desktop, Mobile } from '../../App';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { BACKOFFICE_NAME, flipMeTitle } from '../../helpers/helperFunctions';
import {
  BIG_WHALE,
  KYC_START,
  SETTINGS_SECURITY
  // SETTINGS_VIRTUAL_OFFICE
  // FLIPME_CARDS,
  // AKASHA,
  // POWERPACKS,
  // FINUP_HUBS
  // EARN_BET,
  // DUBAI_TOKEN_PROMOTION
} from '../../routes/routes';
import { color, colors } from '../../styles/GlobalStyles';
import {
  checkAkashaModal,
  getDashboardInfo,
  updateWillyCoins
} from './Dashboard.actions';
import { PackageRankUpgradeNotification } from './Dashboard.types';
import { DashboardNotification } from './DashboardNotification';
import { EarningsComponent } from './EarningsComponent';
import { MoneyBack } from './MoneyBack';
import { NumberOfMembers } from './NumberOfMembers';

import { RankNotification } from './RankNotification';
import { StatisticalComponent } from './StatisticalComponent';
import { SubscriptionWarning } from './SubscriptionWarning';

import { WelcomeSidebar } from './WelcomeSidebar';

import assetsBanner from '../../assets/images/backoffice/assets/assetsBanner.png';
import assetsBannerMobile from '../../assets/images/backoffice/assets/assetsBannerMobile.png';

import finupBanner from '../../assets/images/backoffice/finup/finupBanner.png';
import finupBannerMobile from '../../assets/images/backoffice/finup/finupBannerMobile.png';

import powerPackBanner from '../../assets/images/backoffice/powerPacks/powerPackBanner.png';
import powerPackBannerMobile from '../../assets/images/backoffice/powerPacks/powerPackBannerMobile.png';

import akashaNotRestricted from '../../assets/images/backoffice/akasha/akashaNotRestrictedBanner.png';

import bigWhaleBanner from '../../assets/images/backoffice/bigWhale/bigWhaleBanner.png';
import bigWhaleBannerMobile from '../../assets/images/backoffice/bigWhale/bigWhaleBannerMobile.png';

import transferInProgressBanner from '../../assets/images/backoffice/transactionInProgress/transactionInProgressBanner.png';
import transferInProgressBannerMobile from '../../assets/images/backoffice/transactionInProgress/transactionInProgressBannerMobile.png';

import { WillyMemeCoinsBanner } from './WillyCoins/WillyMemeCoinsBanner';

import { IconTitleStyled } from './DashboardStyled';
import {
  ConnectWallet,
  ConnectWalletStatus
} from '../FlipMeWallet/FlipMeBanner';
import {
  checkRedeemAvailability,
  flipMeGetInfo,
  flipMeRankRewards
} from '../FlipMeWallet/FlipMeWallet.actions';
import { FlipMeWallet } from '../FlipMeWallet/FlipMeWallet';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { RedeemFlipmeCards } from '../Portfolio/RedeemFlipmeCards/RedeemFlipmeCards';
import { RedeemFlipmeCardsStepsEnum } from '../Portfolio/RedeemFlipmeCards/types';
import { CaptionText, H3, H5, P1, P2, P3 } from '../../styles/FontStyles';
import { Flex } from '../../styles/stylesStyled';
import { Button, Flexed } from '../../styles/GlobalComponents';
import Modal from 'react-modal';
import {
  getAkashaWalletSummary,
  getTransferStatus
} from '../Marketplace/Marketplace.actions';
import styled from 'styled-components';
import { NoKyc } from './NoKyc';
import { Withdraw2FARequired } from '../FlipMeWallet/WIthdraw2FARequired';
import { settingsInit } from '../Settings/Settings.actions';
import { TwoFASetup } from './TwoFaSetup';
import axios from 'axios';
import { ErrorToast } from '../../components';

const Dashboard = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation('dashboard');
  const {
    user,
    kycStatus,
    isSideModalChecked,
    isCanadaRestrictedUser,
    canBuyBigWhale,
    isAkashaPopupChecked
    // canBuyAkashaPackages,
    // canBuyPowerPacksPackages,
    // canBuyTradingPackages
  } = useAppSelector((state) => state.auth.userInfo);

  const [modal, setModal] = useState(!isAkashaPopupChecked);

  const { dashboardInfo, joinedAfterCount, willyCoins, loading } =
    useAppSelector((state) => state.dashboard);

  const { verificationStatus } = useAppSelector((state) => state.settings);

  const { walletSummary } = useAppSelector((state) => state.marketplace);

  const [welcome, setWelcome] = useState(!isSideModalChecked);
  const [isFlipmeCardOpen, setIsFlipmeCardOpen] = useState<boolean>(false);
  const [stepFlipmeCard, setStepFlipmeCard] = useState(1);
  const [redeemCardsModal, setRedeemCardsModal] = useState(false);
  const [noKyc, setNoKyc] = useState(false);
  const [noTwoFa, setNoTwoFa] = useState(false);
  const [twoFa, setTwoFa] = useState(false);
  const [isTransferSent, setIsTranferSent] = useState(false);
  const [code, setCode] = useState('');
  const [code2Fa, setCode2Fa] = useState('');

  const [redeemFlipmeCardsStep, setRedeemFlipmeCardsStep] =
    useState<RedeemFlipmeCardsStepsEnum>(RedeemFlipmeCardsStepsEnum.STEP1);

  const history = useHistory();

  // const renderAkasha = () => {
  //   return (
  //     <Link to={AKASHA}>
  //       {/* <Desktop> */}
  //       <img
  //         src={akashaNotRestricted}
  //         alt='akashaBanner'
  //         style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
  //       />
  //     </Link>
  //   );
  // };

  const transferStatus = async () => {
    try {
      await axios.post(`/nft/transfer-all`);

      setIsTranferSent(true);
    } catch (error: any) {
      setIsTranferSent(false);
      ErrorToast(error.response.data.error);
    }
  };

  useEffect(() => {
    dispatch(getDashboardInfo());
    dispatch(flipMeGetInfo());
    dispatch(checkRedeemAvailability());
    dispatch(flipMeRankRewards());
    dispatch(getAkashaWalletSummary());
    dispatch(getTransferStatus());
    dispatch(settingsInit());
  }, [dispatch]);

  useEffect(() => {
    if (!loading) {
      const interval = setInterval(() => {
        dispatch(updateWillyCoins(willyCoins));
      }, willyCoins.changePeriodInSeconds * 1000);

      return () => clearInterval(interval);
    }
  }, [willyCoins]);

  const KycPackageNotifications = () => {
    if (!kycStatus?.isKycCompleted && !kycStatus?.isKycVerified) {
      return (
        <DashboardNotification
          pill={t('kyc_pill')}
          title={t('kyc_title')}
          text={t('kyc_text')}
          buttonOnClick={() => history.push(KYC_START)}
          buttonText={t('verify_now')}
        />
      );
    } else return null;
  };

  // const StartYourJourneyNotification = () => {
  //   if (!dashboardInfo?.user?.currentVirtualOfficeLicence) {
  //     return (
  //       <DashboardNotification
  //         pill={'take the first step today'}
  //         title={'Start your Journey HERE!'}
  //         text={`To achieve the fastest growth, start with the MaVie ${BACKOFFICE_NAME} Subscription.`}
  //         buttonText={`Start with a ${BACKOFFICE_NAME}`}
  //         buttonOnClick={() => history.push(SETTINGS_VIRTUAL_OFFICE)}
  //       />
  //     );
  //   } else return null;
  // };

  const SecurityNotification = () => {
    if (!dashboardInfo?.user?.settings?.signInEmailCodeVerificationEnabled) {
      return (
        <DashboardNotification
          titleColor={color.colors.error500}
          pill={t('notifications.security.pill')}
          title={t('notifications.security.title')}
          text={t('notifications.security.text')}
          buttonText={t('notifications.security.button')}
          buttonOnClick={() => history.push(SETTINGS_SECURITY)}
        />
      );
    } else return null;
  };

  const TransferInProgressBanner = styled.div`
    width: 100%;
    margin-bottom: 40px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      border-radius: 12px;
    }
    button {
      position: absolute;
      right: 50px;
      bottom: 50px;
      width: 250px;
      scale: 1.5;
      transform-origin: right bottom;
      font-weight: 500;
      font-size: 13px;
    }

    @media (max-width: 800px) {
      button {
        position: absolute;
        right: 50%;
        bottom: 20px;
        transform: translateX(50%);
        width: 250px;
        scale: 1;
        font-weight: 500;
        font-size: 13px;
      }
    }
  `;

  if (loading && !dashboardInfo) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'dashboardInfo'}>
      <div style={{ margin: '70px 0' }}>
        <IconTitleStyled>{t('earnings.notifications')}</IconTitleStyled>

        {/* <StartYourJourneyNotification /> */}

        {dashboardInfo?.packageRankUpgradeNotifications?.map(
          (notification: PackageRankUpgradeNotification, index: number) => {
            return <RankNotification notification={notification} key={index} />;
          }
        )}

        {walletSummary?.userAddress && (
          <>
            <TransferInProgressBanner>
              <Desktop>
                <img
                  src={isTransferSent ? transferInProgressBanner : assetsBanner}
                  alt='assetsBanner'
                />
              </Desktop>
              <Mobile>
                <img
                  src={
                    isTransferSent
                      ? transferInProgressBannerMobile
                      : assetsBannerMobile
                  }
                  alt='assetsBannerMobile'
                />
              </Mobile>
              <Button
                negative
                onClick={() => {
                  if (!isTransferSent) {
                    if (!kycStatus?.isKycCompleted) {
                      setNoKyc(true);
                    } else if (!verificationStatus) {
                      setNoTwoFa(true);
                    } else if (verificationStatus) {
                      setTwoFa(true);
                    }
                  }
                }}>
                {isTransferSent
                  ? `Check Your Email ${user?.email}`
                  : 'Transfer All Assets'}
              </Button>
            </TransferInProgressBanner>
          </>
        )}

        {/* {canBuyTradingPackages && (
          <Link to={FINUP_HUBS}>
            <Desktop>
              <img
                src={finupBanner}
                alt='finupBanner'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Desktop>
            <Mobile>
              <img
                src={finupBannerMobile}
                alt='finupBannerMobile'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Mobile>
          </Link>
        )} */}

        <SubscriptionWarning />
        {/* {canBuyPowerPacksPackages && (
          <Link to={POWERPACKS}>
            <Desktop>
              <img
                src={powerPackBanner}
                alt='powerPack'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Desktop>
            <Mobile>
              <img
                src={powerPackBannerMobile}
                alt='powerPack'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Mobile>
          </Link>
        )} */}
        {/* {canBuyAkashaPackages && renderAkasha()} */}

        <WillyMemeCoinsBanner />

        {!isCanadaRestrictedUser && canBuyBigWhale && (
          <Link to={BIG_WHALE}>
            <Desktop>
              <img
                src={bigWhaleBanner}
                alt='bigWhaleBanner'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Desktop>
            <Mobile>
              <img
                src={bigWhaleBannerMobile}
                alt='bigWhaleBannerMobile'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Mobile>
          </Link>
        )}

        {/* FAST START BONUS */}
        {!isCanadaRestrictedUser && <MoneyBack />}

        {/* MY OVERVIEW */}
        <EarningsComponent user={user} backOffice={dashboardInfo} />
        {/* STATISTICAL DATA */}
        <StatisticalComponent backOffice={dashboardInfo} />
        {/* <UnilevelDashboard /> */}

        {/* <ExclusiveGaming /> */}
        {/* <Exclusive /> */}

        <KycPackageNotifications />

        <SecurityNotification />

        <NumberOfMembers backOffice={dashboardInfo} count={joinedAfterCount} />
      </div>
      {!isCanadaRestrictedUser && (
        <WelcomeSidebar open={welcome} setOpen={setWelcome} />
      )}

      <RedeemFlipmeCards
        redeemCardsModal={redeemCardsModal}
        setRedeemCardsModal={setRedeemCardsModal}
        redeemFlipmeCardsStep={redeemFlipmeCardsStep}
        setRedeemFlipmeCardsStep={setRedeemFlipmeCardsStep}
        packageId={null}
      />

      <SidebarModal
        isOpen={isFlipmeCardOpen}
        setOpen={() => {
          setIsFlipmeCardOpen(!isFlipmeCardOpen);
          stepFlipmeCard === ConnectWallet.SECOND_STEP &&
            dispatch(flipMeGetInfo());
        }}
        title={flipMeTitle(stepFlipmeCard)}
        sidebarWidth={'520px'}>
        <FlipMeWallet
          setStep={setStepFlipmeCard}
          step={stepFlipmeCard}
          setIsOpen={setIsFlipmeCardOpen}
        />
      </SidebarModal>

      <SidebarModal
        isOpen={noKyc}
        setOpen={setNoKyc}
        title={t('verify_your_account')}
        sidebarWidth={'508px'}>
        <NoKyc />
      </SidebarModal>

      <SidebarModal
        isOpen={noTwoFa}
        setOpen={setNoTwoFa}
        title={t('verify_your_account')}
        sidebarWidth={'508px'}>
        <Withdraw2FARequired />
      </SidebarModal>

      <SidebarModal
        isOpen={twoFa}
        setOpen={setTwoFa}
        title={t('verify_your_account')}
        sidebarWidth={'508px'}>
        <TwoFASetup
          setTwoFa={setTwoFa}
          transferStatus={transferStatus}
          setCode={setCode}
          setCode2Fa={setCode2Fa}
          code={code}
          code2Fa={code2Fa}
        />
      </SidebarModal>

      <Modal
        isOpen={modal}
        onRequestClose={() => setModal(!modal)}
        overlayClassName='myoverlay'
        closeTimeoutMS={500}
        ariaHideApp={false}
        className={'cameraModal'}>
        <Flexed p='30px' column>
          <H3 caps mb='30' center>
            Super Node Update:
          </H3>
          <P2 mb='40' color={colors.neutral700}>
            Starting August, 14th 2025, we'll remove all $AK1111 tokens from
            your Super Nodes and replace them with $ULX on a dollar-for-dollar
            basis (USD value at transition). <br /> This strategic move protects
            our community, eliminates external risks, and strengthens Mavie's
            independence. No action needed—it's automatic. Your rewards and
            functionality remain unchanged.
          </P2>
          <Button
            onClick={() => {
              setModal(!modal);
              dispatch(checkAkashaModal(history));
            }}>
            Close
          </Button>
        </Flexed>
      </Modal>
    </AnimatedDashboard>
  );
};

export default Dashboard;
